import styled from "styled-components";

export const Container = styled.div`
  min-height: 90vh;
  position: relative;
`;

export const UpperContainer = styled.div`
  min-height: 90vh;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const BannerContent = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  padding: 100px 0 60px 80px;
  width: 620px;
  max-width: 90%;
  z-index: 2;

  @media screen and (max-width: 900px) {
    padding: 80px 0 40px 40px;
    width: 90%;
  }

  @media screen and (max-width: 640px) {
    padding: 60px 0 30px 20px;
    width: 95%;
  }

  .hero-pill-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(40, 6, 249, 0.08);
    backdrop-filter: blur(8px);
    color: #2806f9;
    font-size: 13px;
    font-weight: 700;
    padding: 7px 16px;
    border-radius: 30px;
    border: 1px solid rgba(40, 6, 249, 0.2);
    margin-bottom: 18px;
    letter-spacing: 0.3px;

    .badge-icon {
      color: #ffb800;
      font-size: 12px;
    }
  }

  h1 {
    font-size: 52px;
    font-weight: 800;
    line-height: 1.15;
    color: #0c1538;
    margin-bottom: 18px;
    letter-spacing: -1px;

    .highlight-text {
      color: #2806f9;
      background: linear-gradient(135deg, #2806f9 0%, #6842ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    @media screen and (max-width: 900px) {
      font-size: 42px;
    }

    @media screen and (max-width: 640px) {
      font-size: 32px;
    }

    @media screen and (max-width: 420px) {
      font-size: 26px;
      line-height: 1.2;
    }
  }

  .hero-description {
    font-size: 17px;
    line-height: 1.6;
    color: #434d6b;
    margin-bottom: 30px;
    max-width: 540px;

    @media screen and (max-width: 640px) {
      font-size: 15px;
      margin-bottom: 22px;
    }
  }
`;

export const HeroButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 30px;

  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin-bottom: 24px;
  }

  .hero-btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #2806f9;
    color: #ffffff;
    font-size: 15px;
    font-weight: 700;
    padding: 14px 26px;
    border-radius: 30px;
    text-decoration: none;
    box-shadow: 0 8px 24px rgba(40, 6, 249, 0.32);
    transition: all 0.25s ease;

    &:hover {
      background: #1e03c2;
      transform: translateY(-2px);
      box-shadow: 0 12px 28px rgba(40, 6, 249, 0.42);
      color: #ffffff;
    }

    @media screen and (max-width: 480px) {
      width: 100%;
      padding: 13px 20px;
    }
  }

  .hero-btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #ffffff;
    color: #0c1538;
    font-size: 15px;
    font-weight: 700;
    padding: 13px 22px;
    border-radius: 30px;
    text-decoration: none;
    border: 1.5px solid #d3daf0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.25s ease;

    &:hover {
      border-color: #2806f9;
      color: #2806f9;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(40, 6, 249, 0.12);
    }

    @media screen and (max-width: 480px) {
      width: 100%;
      padding: 12px 20px;
    }
  }
`;

export const HeroTrustStrip = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media screen and (max-width: 480px) {
    gap: 8px;
  }

  .trust-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(6px);
    border: 1px solid #e1e7f5;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 12.5px;
    font-weight: 700;
    color: #0c1538;

    .check-icon {
      color: #2806f9;
      font-size: 13px;
    }

    @media screen and (max-width: 480px) {
      font-size: 11.5px;
      padding: 5px 10px;
    }
  }
`;
